"use client";
import React, { useEffect, useRef, useCallback, useState, memo } from "react";
import { Modal } from "react-bootstrap";
import Image from "next/image";
import Link from "next/link";
import "./index.css";
import { CloseIcon } from "../icons/common-button-icon";
import CustomCarousel from "../custom-carousel/CustomCarousel";
import CustomVideoPlayer from "../custom-video-player/CustomVideoPlayer";

const ReelPopup = ({
  show = () => {},
  allVideos = [],
  onHide = () => {},
  videoSrc = "",
  products = [],
  hasMultiple = false,
  activeReel = {},
  setActiveReel = () => {},
}) => {
  const handleKey = useCallback(
    (e) => {
      if (!show) return;
      if (e.key === "Escape") onHide?.();
    },
    [show, hasMultiple, onHide]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [handleKey]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      // aria-labelled-by="video-modal-title"
      dialogClassName="w-100 video-swiper-modal m-0 vh-100 mw-100 p-2 p-sm-3 p-md-4"
      contentClassName="h-100 bg-transparent border-0"
    >
      <div className="d-flex flex-column gap-3 h-100 overflow-hidden">
        {hasMultiple ? (
          <div className="d-flex align-items-center justify-content-center gap-3 overflow-hidden video-gallery-cover flex-grow-1 position-relative">
            <CustomCarousel
              items={allVideos}
              slidesPerView={1}
              alterClass="justify-content-center"
              initialSlide={activeReel}
              onSlideChange={(index) => setActiveReel(index)}
              loop={true}
              className="video-gallery flex-grow-1 h-100 mx-auto"
              renderItem={(item, i) => (
                <div className="mx-auto slide-card h-100" key={i}>
                  <video
                    autoPlay
                    controls
                    muted
                    poster={item?.thumbnail_url}
                    className="mx-auto"
                  >
                    <source src={item?.video_url}></source>
                  </video>
                </div>
              )}
              hasButtons={true}
              navButtons={{
                btnClassName:
                  "text-white carousal-btn border-0 bg-transparent position-absolute position-lg-static top-50 translate-middle-y z-3",
                prevBtnClass: "start-0",
                nextBtnClass: "end-0",
              }}
            />
          </div>
        ) : (
          <div className="mx-auto slide-card h-100">
            <video
              autoPlay
              controls
              muted
              poster={allVideos[0]?.thumbnail_url}
              className="mx-auto"
            >
              <source src={allVideos[0]?.video_url}></source>
            </video>
          </div>
        )}

        {products?.length > 0 && (
          <div className="d-flex align-items-center justify-content-center w-100 gap-3 overflow-hidden sub-video-gallery mx-auto">
            <CustomCarousel
              items={products}
              slidesPerView={5}
              breakpoints={{
                0: { slidesPerView: 1, spaceBetween: 8 },
                460: { slidesPerView: 2, spaceBetween: 12 },
                768: { slidesPerView: 3, spaceBetween: 12 },
                992: { slidesPerView: 4, spaceBetween: 12 },
                1200: { slidesPerView: 4, spaceBetween: 12 },
                1400: { slidesPerView: 5, spaceBetween: 12 },
                1640: { slidesPerView: 6, spaceBetween: 12 },
              }}
              loop={true}
              className="video-gallery-sub-items mx-auto"
              renderItem={(item, i) => (
                <Link
                  key={i}
                  className="sub-gallery-slide d-flex justify-content-center align-items-center overflow-hidden"
                  href={`/product/${item?.slug || "#"}`}
                  target="_blank"
                >
                  <Image
                    src={item?.images?.[0]}
                    alt="dzh"
                    width={120}
                    className="object-fit-cover d-block w-100"
                    height={120}
                  />
                </Link>
              )}
              hasButtons={true}
              navButtons={{
                btnClassName: "text-white carousal-btn border-0 bg-transparent",
                prevBtnInner: (
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none">
                    <path d="M15 6L9 12L15 18" stroke="white" strokeWidth={2} />
                  </svg>
                ),
                nextBtnInner:(<svg width={24} height={24} viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="white" strokeWidth={2} />
            </svg>)
                 
              }}
              alterClass="justify-content-center"
            />
          </div>
        )}
      </div>
      <button
        className="p-0 border-0 bg-transparent close-btn position-absolute top-0 end-0 text-white z-3"
        onClick={onHide}
      >
        <CloseIcon />
      </button>
    </Modal>
  );
};
export default memo(ReelPopup);
{
  /* <CustomVideoPlayer
                key={i}
                autoPlay
                muted
                className="overflow-hidden"
                preload="auto"
                aspectRatio="auto"
                width="100%"
                showLoadingSpinner
                enableControls={[
                  "ProgressControl",
                  "PlayToggle",
                  "FullscreenToggle",
                ]}
              /> */
}
{
  /* <Modal.Body className="p-0">
        <div
          className="w-100 position-relative"
          style={{ backgroundColor: "#000", overflow: "hidden" }}
        >
          {isLoading && (
            <div
              className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                top: 0,
                left: 0,
                zIndex: 5,
                background: "rgba(0,0,0,0.7)",
                transition: "opacity 0.3s ease-in-out",
              }}
            >
              <div className="spinner-border text-light" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}

          <video
            key={videoSrc}
            ref={videoRef}
            src={videoSrc}
            controls
            autoPlay
            playsInline
            preload="auto"
            loop
            controlsList="nodownload noplaybackrate noremoteplayback"
            style={{
              display: "block",
              width: "100%",
              height: "auto",
              maxHeight: "75vh",
              objectFit: "contain",
              backgroundColor: "#000",
              opacity: fade ? 0 : 1,
              transition: "opacity 0.5s ease-in-out",
            }}
          />

          {products.length > 0 && (
            <div
              className="position-absolute d-flex align-items-center justify-content-center w-100"
              style={{
                bottom: "50px",
                left: 0,
                right: 0,
                zIndex: 10,
              }}
            >
              {products.length > 1 && (
                <button
                  className="btn btn-dark bg-opacity-50 border-0 rounded-circle me-3"
                  style={{
                    width: 40,
                    height: 40,
                    backdropFilter: "blur(4px)",
                  }}
                  onClick={handlePrevProduct}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M15 6L9 12L15 18" stroke="white" strokeWidth="2" />
                  </svg>
                </button>
              )}

              <Link
                href={`/product/${currentProduct?.slug || "#"}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-shrink-0 text-decoration-none"
              >
                <div
                  className="rounded-3 overflow-hidden border border-light"
                  style={{
                    width: 140,
                    height: 140,
                    backgroundColor: "#fff",
                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                    opacity: fadeImage ? 0 : 1,
                    transition: "opacity 0.3s ease-in-out",
                  }}
                >
                  <Image
                    src={imgUrl}
                    alt={currentProduct?.name || "Product"}
                    width={140}
                    height={140}
                    className="object-fit-cover w-100 h-100"
                  />
                </div>
              </Link>

              {products.length > 1 && (
                <button
                  className="btn btn-dark bg-opacity-50 border-0 rounded-circle ms-3"
                  style={{
                    width: 40,
                    height: 40,
                    backdropFilter: "blur(4px)",
                  }}
                  onClick={handleNextProduct}
                >
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M9 6L15 12L9 18" stroke="white" strokeWidth="2" />
                  </svg>
                </button>
              )}
            </div>
          )}

          {hasMultiple && (
            <>
              <button
                type="button"
                onClick={onPrev}
                className="position-absolute btn btn-dark bg-opacity-50 border-0 rounded-circle"
                style={{
                  top: "50%",
                  left: "28px",
                  transform: "translateY(-50%)",
                  width: 44,
                  height: 44,
                  zIndex: 11,
                  backdropFilter: "blur(4px)",
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M15 6L9 12L15 18" stroke="white" strokeWidth="2" />
                </svg>
              </button>

              <button
                type="button"
                onClick={onNext}
                className="position-absolute btn btn-dark bg-opacity-50 border-0 rounded-circle"
                style={{
                  top: "50%",
                  right: "28px",
                  transform: "translateY(-50%)",
                  width: 44,
                  height: 44,
                  zIndex: 11,
                  backdropFilter: "blur(4px)",
                }}
              >
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M9 6L15 12L9 18" stroke="white" strokeWidth="2" />
                </svg>
              </button>
            </>
          )}
        </div>
      </Modal.Body> */
}
